/** Список ошибок валидации поля формы. */
import { Text } from "./Text";

type FormTextErrorProps = {
	errors: readonly unknown[];
	/** Поверх разметки под полем, без зарезервированной строки — для полей в тулбаре */
	floating?: boolean;
};

const hasMessage = (value: unknown): value is { message: string } =>
	typeof value === "object" &&
	value !== null &&
	"message" in value &&
	typeof value.message === "string";

export const FormTextError = ({ errors, floating = false }: FormTextErrorProps) => {
	const messages = errors.flatMap((error) => {
		if (typeof error === "string") return error;
		return hasMessage(error) ? error.message : [];
	});

	if (floating) {
		return messages.length > 0 ? (
			<Text className="absolute top-full left-0 mt-1 rounded-md bg-surface px-1.5 py-0.5 text-xs whitespace-nowrap text-danger shadow-sm">
				{messages.join(" ")}
			</Text>
		) : null;
	}
	return (
		<Text className={`mt-1 min-h-5 ${messages.length > 0 ? "text-danger" : "invisible"}`}>
			{messages.join(" ") || " "}
		</Text>
	);
};
